import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'app/config.service';

@Injectable({
	providedIn: 'root'
})
export class PublicGuardService {
	constructor(
		private router: Router,
		private configService: ConfigService,
	) {}

	async canActivate(): Promise<boolean> {
		if (!this.configService.$public()) {
			// using private domain - deny access
			this.router.navigate(['error/403']);
			return false;
		} else {
			// using public domain - allow access
			return true;
		}
	}
}
